import { TableCell, TableRow } from "@mui/material";
import CompactOrderPreviewTable from "../../Components/CompactOrderPreviewTable";
import UsersDropdown from "../../Components/Dropdown/Users/UsersDropdown";
import DynamicDropdown from "../../Components/Dropdown/DynamicDropdown";
import { IAddEditMarketmakingTask } from "../../Interfaces/marketmaking";
import { getStepInstruments } from "../../Requests/stepRequests";

interface IProps {
  values: IAddEditMarketmakingTask | null;
}

const MarketmakingOrderPreviewTable = ({ values }: IProps) => {
  const getHeader = () => (
    <>
      <TableCell>نام اکانت</TableCell>
      <TableCell>نماد</TableCell>
      <TableCell>نوسان پذیری</TableCell>
      <TableCell>آستانه تغییر</TableCell>
    </>
  );

  const doNothing = () => {};

  const getBody = () => (
    <>
      {values ? (
        <TableRow>
          <TableCell>
            <UsersDropdown
              label=""
              name=""
              onChange={doNothing}
              value={values.accountId}
              disabled
            />
          </TableCell>

          <TableCell>
            <DynamicDropdown
              dropdown={{
                name: "insId",
                placeholder: "نماد",
                disabled: true,
              }}
              value={values.insId}
              getData={getStepInstruments}
              onChange={doNothing}
            />
          </TableCell>
          <TableCell>{values.volatility}</TableCell>
          <TableCell>{values.threshold}</TableCell>
        </TableRow>
      ) : (
        <TableRow className="!relative h-10 !w-full">
          <TableCell className="!w-full !m-auto !flex !justify-center !items-center !h-full !absolute">
            موردی یافت نشد
          </TableCell>
        </TableRow>
      )}
    </>
  );

  return <CompactOrderPreviewTable header={getHeader()} body={getBody()} size="narrow" />;
};

export default MarketmakingOrderPreviewTable;
